import { useEffect } from "react";
import { NaeSSchemaMap } from "../../config/NaeSSchema";
import { useDataCache } from "./DataCacheProvider";
import { useSelector } from "react-redux";
import { SelectorTruckFuelTankNae } from "../Models/ormSelectors";

interface ChildId {
  id: number
}

export interface ITruckFuelTankModelNae {
    id: number,
scopes: any,
badges: any,

}

export const ITruckFuelTankFieldsNae = [
    "id",
    "scopes",
    "badges"
];

export function useTruckFuelTankHookNae(id: number) : ITruckFuelTankModelNae {
  // @ts-ignore
  const element = useSelector((state) => SelectorTruckFuelTankNae(state, id));

  const { addToQueue } = useDataCache();

  useEffect(() => {
    if (!element) {
      addToQueue({
        elementId: id,
        schema: NaeSSchemaMap.TruckFuelTank.schema,
        fields: ITruckFuelTankFieldsNae,
      });
    }
  }, [element, id]);

  return element;
}
